import React from 'react';
import { X, CheckCircle2 } from 'lucide-react';
import { usePurchaseNotifications } from '../hooks/usePurchaseNotifications';
export function PurchaseNotification() {
  const {
    currentNotification,
    isVisible,
    dismiss
  } = usePurchaseNotifications();
  if (!currentNotification) return null;
  return <div className={`fixed bottom-24 md:bottom-6 left-4 md:left-6 z-50 bg-white rounded-lg shadow-xl border border-gray-100 p-4 max-w-sm flex items-start gap-3 transition-all duration-500 ${isVisible ? 'animate-slide-in-right' : 'animate-slide-out-right'}`} data-id="element-17">
      <div className="bg-green-100 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-18">
        <CheckCircle2 className="w-5 h-5 text-success" data-id="element-19" />
      </div>

      <div className="flex-1 pr-4" data-id="element-20">
        <p className="text-sm font-medium text-graphite" data-id="element-21">
          <span className="font-bold" data-id="element-22">{currentNotification.name}</span> de{' '}
          {currentNotification.city}
        </p>
        <p className="text-xs text-gray-500 mt-0.5" data-id="element-23">
          Acaba de comprar el Kit de Supervivencia
        </p>
        <p className="text-[10px] text-gray-400 mt-1" data-id="element-24">
          {currentNotification.timeAgo}
        </p>
      </div>

      <button onClick={dismiss} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Cerrar notificación" data-id="element-25">
        <X className="w-4 h-4" data-id="element-26" />
      </button>
    </div>;
}